module.exports = __webpack_public_path__ + "static/media/person.4ff761ad.svg";